import b2bCopilotDevPlanMarkdown from '@/assets/Artifacts/b2b-copilot-dev-plan.md?raw'

export function buildB2bCopilotPlanArtifactPayload() {
  return {
    markdown: b2bCopilotDevPlanMarkdown,
  }
}

export function buildB2bCopilotPlanZipArtifactPayload() {
  return {
    markdown: `# B2B Copilot — Project Archive

This zip bundle contains the scaffolded **b2b-copilot** repository referenced in the development plan.

## Contents

\`\`\`
b2b-copilot/
├── frontend/           # React + Vite + TypeScript
├── backend/            # FastAPI + LangGraph
├── data/               # Synthetic datasets + seed_data.py
├── docs/               # architecture.md, api.md, benchmark_queries.md
├── scripts/            # setup_db.sh, ingest_all.sh
├── docker-compose.yml
└── README.md
\`\`\`

Extract the archive locally, run \`docker compose up\`, then \`python data/seed_data.py\` to reproduce the demo environment.`,
  }
}
